import React from 'react';
import axios from 'axios';
import { useTimeModal } from '../TimeModal/TimeModalContext';

import { formatDateTime, formatNull } from '../../Utils/GlobalUtils';

import LoadingLines from '../LoadingLines';
import WarningPanel from '../WarningPanel'

const ApplicationsTable = () => {
    const { openTimeModal } = useTimeModal();

    const [users, setUsers] = React.useState([]);
    const [reload, setReload] = React.useState(true);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [freezeButtons, setFreezeButtons] = React.useState(false);

    const [limitForView, setLimitForView] = React.useState(50);
    const [visibilityBtn, setVisibilityBtn] = React.useState(false);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        axios.get(`/api/users?approval=На рассмотрении&limitForView=${limitForView}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(response => {
            if (response.data.length === 0) {
                setUsers([]);
                setWarning('В данный момент заявки отсутствуют');
                setVisibilityBtn(false);
            } else {
                setUsers(response.data);
                setWarning('');
                setVisibilityBtn(response.data.length >= limitForView);
            }
        })
        .catch(error => {
            console.error(error);
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        }).finally(() => {
            setReload(false);
            setLoading(false);
        })
    }, [reload]);

    const changeAccess = (userIdForChange) => {
        const token = localStorage.getItem('token');

        setFreezeButtons(true);

        axios.put(`/api/change-access?userId=${userIdForChange}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then((response) => {
            setReload(true);
            if (response.data == 'На рассмотрении') {
                openTimeModal('Доступ отозван', 'success');
            } else {
                openTimeModal('Доступ разрешён', 'success');
            }
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`Не удалось изменить параметр доступа к системе. ${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
        .finally(() => setFreezeButtons(false));
    };

    const [confirmDelete, setConfirmDelete] = React.useState(null);
    const deleteUser = (userIdForDelete) => {
        const token = localStorage.getItem('token');

        axios.put(`/api/block-unblock-acc?userId=${userIdForDelete}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(() => {
            setReload(true);
            setConfirmDelete(null);
            openTimeModal(`Учётная запись деактивирована`, 'success');
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`Не удалось деактивировать учётную запись. ${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        });
    };
    const handleDeleteClick = (userIdForDelete) => {
        if (confirmDelete === userIdForDelete) {
            deleteUser(userIdForDelete);
        } else {
            setConfirmDelete(userIdForDelete);
        }
    };

    return (
    <div className='pageWrapper'>
        <div className='tableContainer'>
            <div className='tableHeaderWrapper'>
                <div className='tableHeader' style={{gridTemplateColumns: '1fr 1fr 1fr'}}>
                    <div>ФИО</div>
                    <div>Электронная почта</div>
                    <div></div>
                </div>
            </div>
            {loading ? <LoadingLines count='5' heightLine='70' />
            : warning ? <WarningPanel text={warning} inTable={true} buttonText='Повторить попытку' buttonAction={() => setReload(true)} />
            : users.map((user) => (
                <div className='tableRow nonActive' key={user.id} style={{gridTemplateColumns: '1fr 1fr 1fr'}}>
                    <div>
                        <p>{user.lastname} {user.firstname} {user.surname}</p>
                        <span className='description'>Дата и время регистрации: {formatDateTime(user.created_at)}</span>
                    </div>
                    <div>
                        <a 
                            href={`mailto:${user.email}`} 
                            className='aWithLink'
                        >
                            {user.email}
                        </a>
                    </div>
                    <div>
                        <button type='button' className='button miniButton' onClick={() => changeAccess(user.id)} disabled={freezeButtons}>
                            {freezeButtons ? 'Обработка...' : 'Выдать доступ'}
                        </button>
                        <button 
                            type='button' 
                            className='button miniButton' 
                            onClick={() => handleDeleteClick(user.id)}
                            disabled={freezeButtons}
                        >
                            {confirmDelete === user.id ? 'Вы уверены?' : 'Отключить'}
                        </button>
                    </div>
                </div>
            ))}
            {visibilityBtn && <span style={{display: 'flex', justifyContent: 'center'}}><button type='button' className='button' onClick={() => {setLimitForView(prev => prev + 50); setReload(true)}}>Загрузить ещё</button></span>}
        </div>
    </div>
    )
}

export default ApplicationsTable;